import React from 'react';
import PropTypes from 'prop-types';

const LoadingSpinner = ({ 
  text = 'Soketry Solutions...', 
  textColor = '#006400',
  spinnerColor = '#006400',
  size = 'medium'
}) => {
  const sizeClasses = {
    small: 'cs_spinner_sm',
    medium: 'cs_spinner_md',
    large: 'cs_spinner_lg'
  };

  return (
    <div className="cs_loading_spinner">
      <div 
        className={`cs_spinner ${sizeClasses[size]}`}
        style={{ borderTopColor: spinnerColor }}
      />
      <p className="cs_loading_text" style={{ color: textColor }}>
        {text}
      </p>
    </div>
  );
};

LoadingSpinner.propTypes = {
  text: PropTypes.string,
  textColor: PropTypes.string,
  spinnerColor: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};

export default LoadingSpinner; 